import isEqual from "fast-deep-equal/es6";
import { GeoJSONSource, LngLatBounds } from "maplibre-gl";
import { useEffect, useState } from "react";
import { emptyFeatureCollection } from "../../../util/geo";
import { useCaMap, useCaMapEvents, useSearch } from "../../state";
import { fetchSearchHits, hasCriteria } from "../searchHits";
import { applyMatches, hitNames } from "../searchResultLayers";
import { fitBounds } from "../util";

// De percelen die nu oplichten, om ze bij de volgende fetch weer uit te zetten.
let matched = new Set<string>();

async function fetchData(client, filter, bounds, setState, source) {
  const { geojson, boundsToFit } = await fetchSearchHits(client, filter, bounds);
  const map = source.map;
  if (boundsToFit) fitBounds(map, boundsToFit);
  source.setData(geojson);
  map.setLayoutProperty("searchResults", "visibility", "visible");
  // Dezelfde treffers als percelen, voor als de kaart ver genoeg is ingezoomd.
  matched = applyMatches(map, "parcels", matched, hitNames(geojson));
  setState({ filter, bounds, status: "fetched" });
}

interface SearchControlState {
  filter: string;
  bounds: LngLatBounds;
  status: "fetching" | "fetched";
}
export const SearchControl = () => {
  // show filtered fields
  const map = useCaMap();
  const { client, filter, visible } = useSearch();
  const [bounds] = useCaMapEvents("moveend");
  const [state, setState] = useState<SearchControlState | null>(null);

  useEffect(() => {
    if (!map) return;
    const source = map.getSource("searchResults") as GeoJSONSource;
    // Zonder criteria niets ophalen en niets tonen: de zoekpagina staat open
    // met een leeg filter, en dat zou heel Nederland als treffer opleveren.
    if (!(visible && filter && bounds && hasCriteria(filter))) {
      if (state) {
        source.setData(emptyFeatureCollection);
        matched = applyMatches(map, "parcels", matched, []);
        setState(null);
      }
      return;
    }
    if (state) {
      if (state.status === "fetching") return; // bug, should do it later
      if (isEqual(state.filter, filter) && state.bounds === bounds) return;
    }
    setState({ filter, bounds, status: "fetching" });
    fetchData(client, filter, bounds, setState, source);
  }, [map, filter, bounds, state, client, visible]);

  return null;
};
